package fr.anthony.abkweb.data

object CommonLabels {
    const val ABK_NATIVE = "ABK Native"
    const val ACTION_MORE = "En savoir plus ↓"
    const val ACTION_CLOSE = "↑ Refermer"
    const val ACTION_GO_TO_CODE = "Voir le code source →"
    const val NAV_HOME = "Accueil"
    const val NAV_EXPERTISE = "Expertise KMP"
    const val NAV_OUTGO = "Projet Outgo"
    const val NAV_PORTFOLIO = "Portfolio"
    const val NAV_CONTACT = "Me contacter"
    const val NAV_PRIVACY_OUTGO = "Politique de Confidentialité - Outgo"
}

object ButtonLabels {
    const val DARK = "Mode sombre"
    const val LIGHT = "Mode clair"
}

object UrlLabels {
    const val URL_GIT_HOME = "https://github.com/Lycast"
    const val URL_LINKEDIN = "https://www.linkedin.com/in/anthony-brenon-a7761b213"
}

object AboutMeComponentLabels {
    const val TITLE = "Du terrain au numérique : l'art d'évoluer."
    const val DESCRIPTION = "Mon parcours n'est pas une ligne droite, c'est une suite de constructions. J'ai commencé ma vie professionnelle sur le terrain. De l'ébénisterie au transport routier, puis à la menuiserie d'agencement, j'ai forgé mon autonomie et ma capacité à m'adapter à des environnements exigeants."
    const val EXPANDED_TITLE = "Pourquoi le développement ?"
    const val EXPANDED_DESCRIPTION_A = "Parce que j'y ai trouvé la satisfaction de bâtir dans un univers qui me challenge au quotidien. Ma transition vers le développement Android, puis vers l'écosystème Kotlin Multiplatform (KMP), est le fruit d'une volonté : celle de progresser sans cesse et de maîtriser des outils modernes pour developper de meilleurs applications."
    const val EXPANDED_DESCRIPTION_B = "Mon évolution me permet aujourd’hui de concevoir vos applications de A à Z avec une seule exigence : livrer un code propre, performant et évolutif."
}

object FooterLabels {
    const val DESCRIPTION = "L'unification native au service de votre entreprise. Kotlin Multiplatform, du serveur à l'interface."
    const val NAV = "Navigation"
    const val SOCIAL = "Réseaux sociaux"
    const val LINKEDIN = "Linkedin"
    const val GITHUB = "GitHub"
    const val MENTION = "Mentions légales"
    const val TEXT_BOTTOM = "© 2026 ABK Native. Site conçu et développé avec Kotlin & Compose HTML + Tailwind CSS."
}

object PageHomeLabels {
    const val TITLE_A = "Votre application "
    const val TITLE_B = "sur tous les écrans,"
    const val TITLE_C = " sans multiplier les coûts de développement."

    const val DESCRIPTION = "Je suis développeur fullstack. Mon métier est de simplifier le vôtre : je conçois vos applications mobiles et web à partir d'un code source unique. Le résultat ? Une vraie performance native, plus rapide à lancer et beaucoup plus simple à maintenir."
}

object PageExpertiseLabels {
    const val TITLE_A = "L'ingénierie "
    const val TITLE_B = "Kotlin Multiplatform"
    const val DESCRIPTION = "Je crée des architectures fiables et testables, pensées pour durer. L'objectif : garantir une application ultra-fluide et une synchronisation intelligente de vos données, même hors ligne."
    const val TECH_STACK_LABEL = "Stack Technique Maîtrisée"
    const val LINK_CONTACT = "Discuter de vos besoins techniques →"
}

object PageOutgoLabels {
    const val TITLE_A = "Dépensez l'esprit léger grâce à "
    const val TITLE_B = "Outgo."
    const val DESCRIPTION = "Outgo automatise la gestion de votre budget. Simplicité et zéro calcul complexe."

    const val CTA_DOWNLOAD = "Déjà disponible sur Google Play"

    const val FEATURE_1_TITLE = "L'enveloppe"
    const val FEATURE_1_DESC = "Le suivi mensuel instantané. Définissez votre budget, anticipez vos dépenses prévisibles et suivez-les en temps réel."

    const val FEATURE_2_TITLE = "Simplicité"
    const val FEATURE_2_DESC = "Aucune catégorie complexe. Juste l'essentiel pour savoir instantanément où vous en êtes."

    const val FEATURE_3_TITLE = "Le Prévisionnel"
    const val FEATURE_3_DESC = "Anticipez vos fins de mois et projetez-vous en un coup d'œil."

    const val FEATURE_4_TITLE = "Offline-First & Sécurisé"
    const val FEATURE_4_DESC = "Vos données budgétaires vous appartiennent. Gérez vos finances sans connexion internet, avec une synchronisation cloud chiffrée et totalement optionnelle."

    const val STORY_TITLE = "Pourquoi j'ai créé Outgo"

    const val STORY_DESC = "J’ai conçu Outgo au lancement de mon entreprise, quand les dépenses pro et perso commençaient à s’accumuler dangereusement.\n" +
            "En repensant à ma mère qui notait tout dans un carnet pour tenir son budget, j'ai voulu créer un outil moderne capable de retrouver cette rigueur avec la simplicité du numérique. Mon but est simple : vous donner une visibilité instantanée sur ce qu'il vous reste réellement pour vivre, sans calcul complexe.\n" +
            "C'est l'outil que j'utilise aujourd'hui pour ma propre sérénité, et j'espère qu'il vous sera tout aussi indispensable."
}

object PagePortfolioLabels {
    const val TITLE_1_A = "Mon "
    const val TITLE_1_B = "Parcours"
    const val TITLE_2_A = "Mes "
    const val TITLE_2_B = "Réalisations"
}


object PageContactLabels {
    const val TITLE_A = "Discutons de votre "
    const val TITLE_B = "projet"
    const val DESCRIPTION = "Vous avez un besoin spécifique en développement, ou vous souhaitez en savoir plus ? N'hésitez pas à me contacter directement."
}

object PageMentionsLabels {
    const val TITLE = "Mentions Légales"
    const val LEGAL_BLOCK_A_LABEL = "Éditeur du site"
    const val BLOCK_A_TEXT_A = "ABK Native (Anthony Brenon)"
    const val BLOCK_A_TEXT_B = "Micro-entreprise — SIRET : En cours d'immatriculation"
    const val BLOCK_A_TEXT_C = "Domiciliation : Cholet, France"
    const val BLOCK_A_TEXT_D = "Email de contact : contact@abknative.fr"
    const val LEGAL_BLOCK_B_LABEL = "Hébergement"
    const val BLOCK_B_TEXT_A = "GitHub Pages (GitHub, Inc.)"
    const val BLOCK_B_TEXT_B = "88 Colin P Kelly Jr St, San Francisco, CA 94107, États-Unis"
    const val LEGAL_BLOCK_C_LABEL = "Propriété intellectuelle"
    const val BLOCK_C_TEXT_A = "Toute reproduction ou représentation, intégrale ou partielle, du site ou de ses éléments est interdite sans autorisation préalable."
}


object PrivacyOutgoLabels {
    const val TITLE = "Politique de Confidentialité - Outgo"

    const val INTRO_TITLE = "1. Introduction"
    const val INTRO_DESC = "ABK Native exploite l'application mobile Outgo. Cette page vous informe de nos politiques concernant la collecte, l'utilisation et la divulgation des données personnelles lorsque vous utilisez notre service."

    const val DATA_TITLE = "2. Collecte et utilisation des données"
    const val DATA_INTRO = "Outgo a été conçue avec une philosophie \"Offline-First\" pour minimiser la collecte de données. Cependant, pour assurer le fonctionnement de la synchronisation entre vos appareils, nous collectons certains types d'informations :"
    val DATA_POINTS = listOf(
        "Données d'authentification" to "Lors de la création d'un compte, nous utilisons des services tiers (Firebase Authentication) pour sécuriser votre connexion. Cela peut inclure votre adresse e-mail ou votre identifiant d'authentification (Google/Apple).",
        "Saisies budgétaires" to "Vos saisies budgétaires (montants, catégories) sont stockées localement sur votre appareil. Ces informations, saisies manuellement, n'ont aucune valeur légale. Si vous utilisez la synchronisation, ces données sont chiffrées en transit et stockées de manière sécurisée sur nos serveurs. Nous ne vendons, ni n'analysons vos données."
    )

    const val TIER_TITLE = "3. Fournisseurs de services tiers"
    const val TIER_INTRO = "Nous utilisons des services tiers pour faciliter notre service ou analyser son utilisation. Ces tiers n'ont accès à vos données que pour ces tâches spécifiques :"
    val TIER_POINTS = listOf(
        "Firebase Authentication" to "Pour la gestion sécurisée de vos identifiants.",
        "Sentry" to "Pour le suivi technique des crashs (données techniques uniquement, aucune donnée budgétaire ou personnelle)."
    )

    const val SECURITY_TITLE = "4. Sécurité des données"
    const val SECURITY_DESC = "La sécurité de vos données est importante pour nous. Bien qu'aucune méthode de transmission sur Internet ne soit sécurisée à 100 %, nous utilisons des standards industriels reconnus (chiffrement TLS/SSL) pour protéger vos informations personnelles."

    const val CLEAR_DATA_TITLE = "5. Suppression des données"
    const val CLEAR_DATA_DESC = "Vous avez le droit de demander la suppression totale de vos données. Vous pouvez supprimer votre compte et toutes les données associées directement depuis les paramètres de l'application Outgo."

    const val CONTACT_TITLE = "6. Contact"
    const val CONTACT_LINK_TEXT = "notre formulaire de contact"
    const val CONTACT_URL = "https://abknative.fr/contact"
    const val CONTACT_SUB = "Pour toute question, contactez-nous via "
}